const info = {
  CN: {},
  EN: {},
};
export default info;



// WEBPACK FOOTER //
// ./src/language/product/index.js